import React, { useState } from "react";

interface ExportSelectProps {
  orders: any[];
  selectedDate: string;
  selectedDate2: string;
  handleExport: (type: string, orders: any[], startDate: string, endDate: string) => void;
}

const ExportSelect: React.FC<ExportSelectProps> = ({ orders, selectedDate, selectedDate2, handleExport }) => {
  const [selected, setSelected] = useState("Select");

  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelected(value);

    if (value !== "Select") {
      await handleExport(value, orders, selectedDate, selectedDate2);

      // ✅ Reset back to default after export
      setSelected("Select");
    }
  };

  return (
    <div className="export-select-area">
      <label className="export-select-label">Choose export file:</label>
      <select
        className="date-range-select"
        value={selected}
        onChange={handleChange}
      >
        <option value="Select" disabled>
          Select
        </option>
        <option value="CSV">CSV</option>
        <option value="PDF">PDF</option>
      </select>
    </div>
  );
};

export default ExportSelect;
